import { type ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

import { LastSignInNotice } from '@/features/my-account/components/LastSignInNotice';

/**
 * Simpler than merchant-dashboard's own AppShell: no `useActiveShop()` (no
 * shop concept on this app's routes at all), no command palette (two real
 * screens do not need one) — `useTheme()` is called once, directly inside
 * `Topbar`, since there is no second instance here to desync against.
 */
export function AppShell(): ReactElement {
  return (
    <div className="flex h-dvh w-full bg-ground">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar />
        <LastSignInNotice />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
